/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { APIEnvs, KeysAvaiable, ReturnResponseType } from '_core/types';
import { TypeOfConstants, TypeOfEnv } from '_core/types/ContantsTypes';
import { Bundle } from '_core/util';

const LIST_OF_KEYS: TypeOfEnv = {};

export const updateConstants = (environment: APIEnvs, dados: any): boolean => {
  LIST_OF_KEYS[environment] = dados;
  return true;
};

/**
 *  @param 'googleMaps' | 'recaptcha' | 'bugsnag' | 'siebel'
 *  @example getConstants('googleMaps', 'bugsnag') ou getConstants()
 */
export const getConstants = (...params: KeysAvaiable[]): ReturnResponseType => {
  const config = Bundle.getValue('config');
  const environment = config.service.environment;
  const objConstants: TypeOfConstants = LIST_OF_KEYS[environment];

  let response = {};
  if (params.length > 0) {
    params.map((item: string) => {
      Object.defineProperty(response, item, {
        value: objConstants[item],
      });
    });
  } else {
    response = objConstants;
  }

  const commonMessage = {
    message: 'Channel não utiliza essa constante que você está querendo usar.',
  };
  return Object.keys(response).length === 0 && response.constructor === Object
    ? response
    : commonMessage;
};
